import axios from 'src/axios'
import { CONVERSIONROUTES } from 'src/router/Api'

export interface CommunityCmsListParams {
	page?: number
	limit?: number
	q?: string
	category_id?: string
	main_category_id?: string
	location?: string
	province?: string
	country?: string
	status?: string
}

export type CommunityLocationScope = 'vietnam' | 'other'

export interface CommunityLocationStat {
	location_key: string
	location_label: string
	community_count: number
}

export const getCommunityCmsList = async (
	params: CommunityCmsListParams,
) => {
	return await axios.get(CONVERSIONROUTES.cmsCommunities, { params })
}

export const getCommunityCmsStatistics = async () => {
	return await axios.get(CONVERSIONROUTES.cmsCommunityStatistics)
}

export const getCommunityCmsCategories = async () => {
	return await axios.get(CONVERSIONROUTES.cmsCommunityCategories)
}

export const getCommunityCmsLocations = async () => {
	return await axios.get(CONVERSIONROUTES.cmsCommunityLocations)
}

export const getCommunityCmsLocationStats = async (
	scope: CommunityLocationScope,
) => {
	return await axios.get(CONVERSIONROUTES.cmsCommunityLocationStats, {
		params: { scope },
	})
}
